import axios from 'axios';

import { env } from '@/env';
import { WhatsNewCmsResponse } from '@/types/cms/whats-new.type';

const createCMSClient = () => {
  const strapiUrl = env.NEXT_PUBLIC_STRAPI_URL;

  const axiosClient = axios.create({
    baseURL: strapiUrl,
    headers: {
      Authorization: `Bearer ${env.NEXT_PUBLIC_BEARER_TOKEN}`,
      'Content-Type': 'application/json',
    },
  });

  return {
    getAllWhatsNew: () =>
      axiosClient.get<WhatsNewCmsResponse>(`/api/what-s-new?populate=deep`),
  };
};

export { createCMSClient };
